export enum BOOKING_STEPS {
  CLIENT_INFO,
  PATIENT_INFO,
  NOTIFICATION_SETTINGS,
  ADDITIONAL_INFO,
  SELECT_APPOINTMENT,
  CONFIRMATION,
  STATUS
}
